import { AppState } from 'src/store';

export const poppersSelectors = {
  selectIsPoppers: (state: AppState) => !!Object.entries(state.poppers).length,
};
